module.exports = __webpack_public_path__ + "static/media/3rnets.0682ac7c.png";